// extracted by mini-css-extract-plugin
export default {"dtg-offline-indicator":"dtg-offline-indicator_LtOzm","dtg-offline-indicator__icon":"dtg-offline-indicator__icon_zjje7"};